import * as React from 'react';
import { memo, useCallback, useEffect } from 'react';
import { Form, Input, Modal, Row, Space, Typography } from 'antd';
import { Banner, BannerFormProps, Languages, ModalFormMode } from '../admin-banners.type';
import Button from '/react4xp/mixins/ui/button/button';
import { languages } from '../admin-banners.constants';
import ImageUploadComponent from './image-upload-component';

export const ModalForm = memo(
    ({ onSubmit, mode, initialValues, close, enableCrop }: BannerFormProps) => {
        const [form] = Form.useForm<Banner>();

        const title =
            mode === ModalFormMode.CREATE ? 'Создать новый баннер' : 'Редактировать баннер';

        const handleCancel = () => {
            close();
        };

        const handleFinish = (values: Banner) => {
            onSubmit(values);
            close();
        };

        // useEffect to prevent memoization of previous item form values
        useEffect(() => {
            form.setFieldsValue(initialValues);
        }, [initialValues]);

        const selectImage = useCallback((image: { id: string }) => {
            form.setFieldValue('imageId', image.id);
        }, []);

        const getInitialImageId = useCallback(() => initialValues?.imageId, [initialValues]);

        return (
            <Modal
                title={title}
                open={mode !== ModalFormMode.CLOSE}
                footer={null}
                onCancel={handleCancel}
            >
                <Form
                    labelCol={{ span: 5 }}
                    form={form}
                    onFinish={handleFinish}
                    initialValues={initialValues}
                >
                    <Form.Item
                        hidden
                        name="id"
                    >
                        <Input />
                    </Form.Item>
                    <Typography.Title level={4}>Наименование</Typography.Title>
                    {Object.keys(languages).map((language: Languages) => (
                        <Form.Item
                            key={language}
                            label={languages[language]}
                            name={`title_${language}`}
                            rules={[{ required: true, message: 'Обязательное поле' }]}
                        >
                            <Input />
                        </Form.Item>
                    ))}
                    <Typography.Title level={4}>Ссылка</Typography.Title>
                    {Object.keys(languages).map((language: Languages) => (
                        <Form.Item
                            key={language}
                            label={languages[language]}
                            name={`url_${language}`}
                            rules={[{ required: true, message: 'Обязательное поле' }]}
                        >
                            <Input />
                        </Form.Item>
                    ))}
                    <Typography.Title level={4}>Изображение</Typography.Title>

                    <Form.Item
                        labelCol={{ span: 24 }}
                        name={'imageId'}
                        rules={[{ required: true, message: 'Обязательное поле' }]}
                    >
                        <ImageUploadComponent
                            selectImage={selectImage}
                            getInitialImageId={getInitialImageId}
                            enableCrop={enableCrop}
                        />
                    </Form.Item>

                    <Row justify="end">
                        <Space>
                            <Form.Item>
                                <Button onClick={close}>Отменить</Button>
                            </Form.Item>
                            <Form.Item>
                                <Button
                                    htmlType="submit"
                                    color="gold"
                                >
                                    Сохранить
                                </Button>
                            </Form.Item>
                        </Space>
                    </Row>
                </Form>
            </Modal>
        );
    }
);
